var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n        stroke: #dc1e37;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 6px;\r\n      }\r\n\r\n      .st1 {\r\n        display: none;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #dc1e37;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "60 76.42 86.27 98.18 86.27 21.82 33.73 21.82 33.73 98.18 60 76.42"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1\\u306E\\u30B3\\u30D4\\u30FC",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1\\u306E\\u30B3\\u30D4\\u30FC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.73,101.18c-.43,0-.87-.09-1.28-.29-1.05-.49-1.72-1.55-1.72-2.71V21.82c0-1.66,1.34-3,3-3h52.54c1.66,0,3,1.34,3,3v76.37c0,1.16-.67,2.22-1.72,2.71-1.05.5-2.3.34-3.19-.4l-24.35-20.17-24.35,20.17c-.55.45-1.23.69-1.91.69ZM36.73,24.82v66.98l21.35-17.69c1.11-.92,2.72-.92,3.83,0l21.35,17.69V24.82h-46.54Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/Favorite.995a8213c1c3d9962b76e2a267636c0c.svg";
export { ForwardRef as ReactComponent };